import { Link } from 'react-router'
import { trackUpgradeClicked, trackUpgradeFromQuotaWall } from '../../lib/analytics'

interface Props {
  isOpen: boolean
  onClose: () => void
  reason?: string
}

export default function UpgradeModal({ isOpen, onClose, reason }: Props) {
  if (!isOpen) return null

  return (
    <div
      role="dialog"
      aria-modal="true"
      data-testid="upgrade-modal"
      className="fixed inset-0 bg-void/80 flex items-center justify-center z-50"
    >
      <div className="bg-obsidian border border-carbon rounded p-8 max-w-md w-full mx-4 space-y-4">
        <h3 className="text-h4 text-chalk">Upgrade Required</h3>
        {reason && <p className="text-body-sm text-steel">{reason}</p>}
        <p className="text-body-sm text-steel">
          Upgrade to Pro to process longer videos and unlock more features.
        </p>
        <div className="flex gap-3">
          <Link
            to="/pricing?plan=pro"
            className="flex-1 bg-signal hover:bg-signal-hover text-white text-callout font-medium py-2 px-4 rounded text-center transition-colors"
            onClick={() => {
              trackUpgradeClicked(reason ?? 'upgrade_modal')
              trackUpgradeFromQuotaWall('warning_banner')
            }}
          >
            View Plans
          </Link>
          <button
            onClick={onClose}
            className="flex-1 bg-carbon hover:bg-carbon/80 text-chalk text-callout font-medium py-2 px-4 rounded transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
